import ListBottomSheetWrapper from "../ListBottomSheetWrapper";
import SortViewMainContent from "./SortViewMainContent";
import type { SortBy } from "./types";
import type { SortByDataType, SortOrderType } from "./types";

type TopicSortBottomSheetProps = {
	showModal: boolean;
	handleSheetClose: () => void;
	handleSortByChange: (type: SortBy) => void;
	data: SortByDataType[];
	selectedSortByItem?: SortByDataType;
	sortOrderType: SortOrderType;
};

const TopicSortBottomSheet = ({
	showModal,
	handleSheetClose,
	handleSortByChange,
	data,
	selectedSortByItem,
	sortOrderType,
}: TopicSortBottomSheetProps) => {
	return (
		<ListBottomSheetWrapper
			showModal={showModal}
			handleSheetClose={handleSheetClose}
			title="Sort by"
			snapPoints={["50%", "80%"]}
		>
			<SortViewMainContent
				handleSortByChange={handleSortByChange}
				data={data}
				selectedSortByItem={selectedSortByItem}
				sortOrderType={sortOrderType}
			/>
		</ListBottomSheetWrapper>
	);
};

export default TopicSortBottomSheet;
